import { Component } from '@angular/core';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { MobileHeaderComponent } from '../components/mobile-header/mobile-header.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FooterComponent } from '../components/footer/footer.component';
@Component({
  selector: 'app-interview-viewer',
  standalone: true,
  imports: [SidebarComponent, CommonModule, FormsModule, MatButtonModule, MatFormFieldModule, MatInputModule, FooterComponent],
  templateUrl: './interview-viewer.component.html',
  styleUrl: './interview-viewer.component.scss'
})
export class InterviewViewerComponent {
  isPasswordCorrect = false;
  password = '';
  passwordIncorrect = false;

  checkPassword() {
    if (this.password === 'amckxn1nsa882smjl82176') { 
      this.isPasswordCorrect = true;
    } else {
      this.passwordIncorrect = true;
    }
  } 
}
